import React, { useRef, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
} from '@mui/material';
import { useLoginStore } from '../../../stores/AuthStatusStore';

interface LoginDefaultProps {
  corretor?: boolean;
}

const LoginDefault: React.FC<LoginDefaultProps> = ({ corretor }) => {
  const [login, setLogin] = useState<string>('');
  const [senha, setSenha] = useState<string>('');
  const [error, setError] = useState<string>('');
  const logado = useLoginStore(x => x.login);
  const setLogado = useLoginStore(x => x.setLogin);
  const [loading, setLoading] = useState<boolean>(false);
  const [envioCorretor, setEnvioCorretor] = useState<boolean>(false);

  const handleLogin = async () => {
    const urlBase = process.env.REACT_APP_URL_BASE;
    const Token = process.env.REACT_APP_TOKEN_S4E_V2;
    const TokenCorretor = '2FOPQWEUIRNPGUIQNAWEUIBGRUIQ3489GUBWVN4%@#@uyghin=';
    const cpfCleaned = login.replace(/[^\d]+/g, '');
    const url = envioCorretor
      ? `${urlBase}/SYS/services/LoginService.aspx/Corretor`
      : `${urlBase}/SYS/services/LoginService.aspx/Colaborador`;

    const body = {
      token: envioCorretor ? TokenCorretor : Token,
      cpf: envioCorretor ? undefined : cpfCleaned,
      cpfcnpj: !envioCorretor ? undefined : cpfCleaned,
      senha: senha,
      tipoIdentificacao: !envioCorretor ? undefined : 0,
    };
    const response = await axios.post(url, body);
    if (response.data.codigo === 1) {
      setLogado(true);
      const timeout = setTimeout(() => {
        alert('Sua sessão expirou. Faça login novamente.');
        setLogado(false);
      }, 30 * 60 * 1000);
    } else {
      alert('Erro ao fazer Login');
    }
  };

  const handleLoginChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setLogin(event.target.value);
    setError('');
  };
  const handleSenhaChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setSenha(event.target.value);
    setError('');
  };

  return (
    <Container>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        padding="2rem"
      >
        <Paper
          elevation={3}
          style={{ padding: '2rem', maxWidth: '700px', width: '100%' }}
        >
          <form>
            {corretor && (
              <div className="max-w-md mx-auto p-4">
                <div className="flex items-center mb-4">
                  <span className={`mr-2 ${!envioCorretor ? 'font-bold' : ''}`}>
                    Colaborador
                  </span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={envioCorretor}
                      onChange={() => setEnvioCorretor(!envioCorretor)}
                    />
                    <div
                      className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 
                  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] 
                  after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border 
                  after:rounded-full after:h-5 after:w-5 after:transition-all dark:bg-gray-700 peer-checked:bg-blue-600"
                    ></div>
                  </label>
                  <span className={`ml-2 ${envioCorretor ? 'font-bold' : ''}`}>
                    Corretor
                  </span>
                </div>
              </div>
            )}
            <TextField
              fullWidth
              margin="normal"
              label="Login"
              variant="outlined"
              value={login}
              onChange={handleLoginChange}
              error={!!error}
              helperText={error}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Senha"
              variant="outlined"
              type="password"
              value={senha}
              onChange={handleSenhaChange}
              error={!!error}
              helperText={error}
              required
            />

            <Box mt={2} display="flex" justifyContent="flex-end">
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={handleLogin}
              >
                {loading ? <CircularProgress size={24} /> : 'Login'}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Container>
  );
};

export default LoginDefault;
